export const CREATE_ALERT_ACTION = 'CREATE_ALERT';
export const DELETE_ALERT_ACTION = 'DELETE_ALERT';
export const ALERT_CONFIRMATION = 'ALERT_CONFIRMATION';
export const ALERT_DISMISS = 'ALERT_DISMISS';
